module.exports = __webpack_public_path__ + "img/top.41ada94a.png";